export const version = '0.6';
export const USER_DATE_FORMAT = 'DD.MM.YYYY';
export const USER_DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
export const API_FEAT_DATE_FORMAT = 'YYYY-MM-DD';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const API_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const REQUIRED_APP_VER = '3.0.1';

export const SNEGAPP_DOWNLOAD_LINK = 'https://disk.yandex.ru/d/pLpYG82P1E8J8g';
